import { useContext } from 'preact/hooks';
import BadgeRecommended from './BadgeRecommended';
import { selectIcon } from '../templates/place';
import { formatRecommendedDisplayType, createPlace } from './AutoCompleteSelect/displayTypes';
import SelectContext from './AutoCompleteSelect/context';
import useWidgetConfig from '../context/WidgetConfig';

const RouteOption = ({
  showRecommendedIcon,
  showRecommendedBadge,
  route,
  onSelect,
  showOrigin,
}) => {
  const { origin, destination } = route;
  const { displayType } = useWidgetConfig();
  const { hybridSearchEnabled = false } = useContext(SelectContext) || {};

  const handleOnSelect = () => {
    const { origin, destination } = route;

    if (!origin && destination) {
      route.field = 'destination';
    }
    onSelect(route);
  };

  let originText,
    destinationText = '';

  if (showOrigin) {
    const originPlace = createPlace(origin);
    originText = formatRecommendedDisplayType(originPlace, displayType, hybridSearchEnabled);
  }
  const destinationPlace = createPlace(destination);
  destinationText = formatRecommendedDisplayType(
    destinationPlace,
    displayType,
    hybridSearchEnabled
  );

  const icons = icon => {
    return (
      <div
        className="route-icon"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: selectIcon(icon, false),
        }}
      />
    );
  };

  return (
    <div className="route-option" onClick={handleOnSelect}>
      <div className="route-option-wrapper">
        {icons(showRecommendedIcon ? 'sparkle' : 'recent')}

        <div className="route-option-route">
          {showOrigin && <p className="route-option-terminal">{originText}</p>}
          <p className="route-option-terminal">{destinationText}</p>
        </div>
      </div>

      {showRecommendedBadge && <BadgeRecommended />}
    </div>
  );
};

export default RouteOption;
